import { useQuery } from '@tanstack/react-query';

import map from 'lodash/map';

import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { RequestDataArray } from 'src/types/requestData';
import {
  getRequest,
  paginationMapper,
  resolveQueryString,
} from 'src/utils/request';

const mapUnavailabilities = (
  attributes: UCM.UnavailabilityRawType,
  id: string,
): UCM.UnavailabilityType => {
  return {
    id,
    kind: attributes.kind,
    uuid: attributes.uuid,
    endsOn: attributes.ends_on,
    startsOn: attributes.starts_on,
    status: attributes.status,
  };
};

const getUnavailabilities = async (
  userId: string,
  params: Record<string, string | number>,
) => {
  const filters = resolveQueryString([{ user_id: userId }], params);

  const {
    data: { data, meta },
  } = await getRequest<
    RequestDataArray<UCM.UnavailabilityRawType, UCM.MetaRawType>
  >(`${API.GET.userUnavailabilities}${filters}`);

  return {
    meta: paginationMapper(meta),
    data: map(data, ({ attributes, id }) =>
      mapUnavailabilities(attributes, id),
    ),
  };
};

export const useGetUnavailabilities = (
  userId: string,
  params: Record<string, string | number>,
  config: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.USER_UNAVAILABILITIES, userId, params],
    queryFn: () => getUnavailabilities(userId, params),
    ...config,
  });
};
